import { initialPagination } from '@app/constants/pagination';

const tableDataInit = {
  data: [],
  pagination: initialPagination,
  filterOptions: {
    uniqueProviders: [],
    uniqueRangeTypes: [],
    uniqueRangeDays: [],
    uniqueSalesPoints: [],
  },
  loading: false,
  error: false,
};

export { tableDataInit };
